import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '../../helpers/api-helper';
import ProposalApi from '../../../infrastructure/proposal-api';
export const createProposalAsync = createAsyncThunk('proposal/create', async (proposal, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalApi.createProposal(proposal);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getProposalsAsync = createAsyncThunk('proposal/getAll', async (companyId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalApi.getProposals(companyId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteProposalAsync = createAsyncThunk('proposal/delete', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalApi.deleteProposal(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteProposalsAsync = createAsyncThunk('proposal/deleteMany', async (ids, { rejectWithValue, fulfillWithValue }) => {
    try {
        const promises = ids.map((id) => ProposalApi.deleteProposal(id));
        await Promise.all(promises);
        return fulfillWithValue(ids);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDocumentProcessStatusAsync = createAsyncThunk('proposal/getStatus', async (args, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalApi.getDocumentProcessStatus();
        // Filter by companyId if provided and not 'ALL'
        let data = response.data;
        if (args.companyId && args.companyId !== 'ALL') {
            data = data.filter(proposal => proposal.companyId === args.companyId);
        }
        return fulfillWithValue(data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
